<template>
    <div class="w-100 user-modal-register-plan-select-cm-view px-2">
        <div class="mb-3 text-center">
            <p class="font-weight-bold font-size-200 mb-0">
                {{ translate('Get Credits for') }}
            </p>
        </div>

        <div v-if="isNewAccount" class="d-flex justify-content-center text-center mb-4 ml-n1 mt-n3 flex-wrap">
            <div class="flex-grow-1 ml-1 mt-3 white-space-nowrap">
                <label
                    class="btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100 d-inline-flex align-items-center"
                    :class="{ 'outline-info shadow-info': isProductionSelected }"
                >
                    <input
                        data-user-modal-input-plan-cm-conversion-minutes
                        type="radio"
                        class="mr-4 vuetiful-form-radio-button"
                        name="u_plan"
                        value="cm_production"
                        v-model="selectedPlan" />{{ translate('Production') }}<i class="far fa-rocket ml-2_ lh-inherit"></i
                ></label>
            </div>

            <div class="flex-grow-1 ml-1 mt-3 white-space-nowrap position-relative">
                <label
                    class="btn btn-white rounded border btn-lg mb-0 py-3 px-4 w-100 d-inline-flex align-items-center"
                    :class="{
                        'outline-info shadow-info': isDevelopmentSelected,
                    }"
                >
                    <input
                        data-user-modal-input-plan-cm-developer
                        type="radio"
                        class="mr-4 vuetiful-form-radio-button"
                        name="u_plan"
                        value="cm_development"
                        v-model="selectedPlan" />{{ translate('Development')
                    }}<i class="far fa-mug-hot ml-2_ lh-inherit"></i
                ></label>
            </div>
        </div>

        <div class="mb-4 rounded bg-white border p-4">
            <p class="mb-1 font-size-150">{{ translate('API credtis') }}</p>
            <div class="color-stripe flex-row w-100 mb-4">
                <div v-for="n in 8" :class="'bg-main-' + n"></div>
            </div>

            <div class="mb-4 position-relative w-100 overflow-x-hidden" style="min-height: 195px">
                <ul v-if="isProductionSelected" class="list-unstyled mb-0 w-100">
                    <li
                        v-for="(feature, idx) in features"
                        class="py-3 d-flex align-items-baseline"
                        :class="{ 'border-top': idx !== 0 }"
                    >
                        <i class="fa fa-check text-success"></i>
                        <span class="pl-1" v-html="feature"></span>
                    </li>
                </ul>

                <div v-else class="pt-2 text-left w-100">
                    <p>
                        {{ translate('For developing purposes you have 30 Credits for free every 24 hours.') }}
                    </p>
                    <p v-html="apiDocsLine"></p>
                    <p v-html="supportLink" @click.stop.prevent="onSupportTextClicked"></p>
                    <p class="mb-0">{{ translate('Happy coding!') }}</p>
                </div>
            </div>

            <div class="bg-gray-light rounded p-3 d-flex flex-column align-items-start">
                <strong class="font-size-125 mb-1">
                    {{ translate('What is a Credit') }}
                </strong>
                <div>
                    {{
                    translate('A Credit is the amount of processing time a file uses on our servers. For example, if the file processing takes two minutes, then you spend two Credits. Certain premium jobs use more Credits per minute as specified on our pricing page.')
                    }}
                </div>
            </div>
        </div>

        <ButtonWithLoadingState
            data-user-modal-button-submit
            class="btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4"
            icon="fa fa-arrow-right lh-1"
            :text="translate('Continue')"
            :is-state-loading="isSubmitting"
            :show-icon-after-text="true"
            @click.stop.prevent="goToChooseBilling"
        ></ButtonWithLoadingState>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { userModalRoute } from '../router';
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import { translate } from '../../../../../qaamgo/helper/translate';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation';
import { getLocationHashWithoutModalPageFragment } from '../modal-fragment-helper';

export default {
    name: 'RegisterPlanSelectConversionMinutesView',
    components: { LoadingAnimation, ButtonWithLoadingState },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        isNewAccount: {
            type: Boolean,
            default: true,
        },
    },
    beforeMount() {
        if (!testIsNonEmptyString(this.selectedPlanStore)) {
            this.store.userPaymentModal.setSelectedPlan('cm_production');
        }
    },
    mounted() {
        this.store.userPaymentModal.setSubmitting(false);
    },
    watch: {
        selectedPlan(plan) {
            this.store.userPaymentModal.setSelectedPlan(plan);
        },
        selectedPlanStore(plan) {
            if (this.selectedPlan !== plan) {
                this.selectedPlan = plan;
            }
        },
    },
    computed: {
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.userPaymentModal.isSubmitting;
        },
        /** @return {User} */
        storeUser() {
            return this.store.user.getUser;
        },
        selectedPlanStore() {
            return this.store.userPaymentModal.selectedBilling;
        },
        isProductionSelected() {
            return this.selectedPlan === 'cm_production';
        },
        isDevelopmentSelected() {
            return this.selectedPlan === 'cm_development';
        },
        features() {
            const featureTexts = [];

            featureTexts.push(translate('Access to all of our REST API endpoints'));
            featureTexts.push(translate('Two week <strong>money back guarantee</strong>, no questions asked'));
            featureTexts.push(translate('Free customer support'));
            featureTexts.push(translate('<strong>For production</strong>: buy Credits in the next step'));

            return featureTexts;
        },
        apiDocsLine() {
            return translate(
                'As a starter, please check our <a href="%linkApiDocs%">API Documentation</a> and the <a href="%linkSupportedFormats%">formats we support</a>.',
                {
                    '%linkApiDocs%': 'https://www.api2convert.com/docs/index.html" target="_blank',
                    '%linkSupportedFormats%': 'https://www.api2convert.com/file-formats" target="_blank',
                }
            );
        },
        supportLink() {
            return translate('If you have any questions, please <a href="%linkSupport%">let us know</a>', {
                '%linkSupport%': '#" id="modalSupportLink',
            });
        },
    },
    methods: {
        onSupportTextClicked(event) {
            const isSupportLinkClicked = event?.target?.id === 'modalSupportLink';

            if (!isSupportLinkClicked) {
                return;
            }

            this.$router.push({
                name: userModalRoute.CONTACT_US_FORM,
                params: {
                    showBackButton: true,
                    containerStyle: 'width: 100%; max-width: 480px; padding-left: 1rem; padding-right: 1rem;',
                },
            });
        },
        goToChooseBilling() {
            if (!this.isNewAccount || this.isProductionSelected) {
                globalLogger.log('user modal - plan select - cm_production');

                this.$router.push({
                    name: userModalRoute.REGISTER_CHOOSE_BILLING,
                });

                return;
            }

            if (this.storeUser.isEnabled()) {
                this.store.userPaymentModal.close();
                // reload window to make sure user/js has correct state
                window.location.hash = getLocationHashWithoutModalPageFragment();

                window.allowLeave = true;
                window.location.reload();

                return;
            }

            globalLogger.log('user modal - plan select - cm_development');

            this.$router.push({
                name: userModalRoute.REGISTER_CONFIRMATION_MAIL_SENT,
            });
        },
    },
    data() {
        return {
            selectedPlan: 'cm_production',
        };
    },
};
</script>

<style>
.user-modal-register-plan-select-cm-view {
    max-width: 480px;
}
</style>
